import { heroStats, heroImages } from "@/mocks/home";

type HeroSectionProps = {
  onOpenSubmit: () => void;
};

export default function HeroSection({ onOpenSubmit }: HeroSectionProps) {
  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-background-200 bg-background-100">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
      <div className="pointer-events-none absolute -right-16 bottom-0 h-64 w-64 rounded-full bg-accent-100/70 blur-3xl" />

      <div className="relative mx-auto grid max-w-[1440px] grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-[1.35fr_1fr] lg:items-center lg:gap-16">
        <div className="animate-riseIn">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-100/70 px-3 py-1.5 text-xs font-label font-medium text-primary-700">
            <i className="ri-fire-line text-sm" />
            独家来源 · 内部爆料 · 匿名投稿
          </span>

          <h2 className="mt-5 font-heading text-[30px] font-bold leading-[1.25] text-foreground-950 sm:text-4xl md:text-[46px] md:leading-[1.2]">
            还没被公开的那句话，
            <br className="hidden sm:block" />
            先在这里<span className="text-primary-600">留下痕迹</span>
          </h2>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            15黑料网汇集内部爆料、匿名投稿与密料渠道。如果你关注第一手黑料，或想了解独家信息来源，
            这里提供持续更新的爆料入口与信源标注 —— 每条线报都写清来源等级，
            满足对未公开信息好奇心的同时，也把判断权交还给你。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <button
              type="button"
              onClick={onOpenSubmit}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill text-base" />
              我要匿名投稿
            </button>
            <a
              href="#topics"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-layout-grid-line text-base" />
              逛逛话题墙
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-300 pt-7 sm:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="flex items-center gap-1.5 text-xs text-foreground-600">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className={`${stat.icon} text-sm`} />
                  </span>
                  {stat.label}
                </dt>
                <dd className="mt-1.5 font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative animate-riseIn" style={{ animationDelay: "120ms" }}>
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2 h-52 w-full overflow-hidden rounded-lg border border-background-300 md:h-64">
              <img
                src={heroImages.main}
                alt="匿名爆料信源封存档案氛围插图"
                title="15黑料网 独家来源 内部爆料"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="col-span-2 h-40 w-full overflow-hidden rounded-lg border border-background-300 md:h-48">
              <img
                src={heroImages.side}
                alt="内部爆料密料渠道档案室氛围插图"
                title="15黑料网 匿名投稿 第一手黑料"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="mt-4 flex items-center justify-between rounded-lg border border-background-300 bg-background-50 px-4 py-3.5">
            <div className="flex items-center gap-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-user-voice-line text-sm" />
              </span>
              <span className="text-xs text-foreground-700">当前 527 人正在围观讨论</span>
            </div>
            <span className="flex items-center gap-1.5 text-xs font-label font-medium text-primary-700">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulseDot" />
              实时
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}